import type { KiStatus, KiVorschlag } from '@beholder/shared/module/ki';
import { Link } from 'react-router-dom';
import { api, modulPfad } from '../../core/api';
import type { ModulSeiteProps, WebModul } from '../../core/modul';
import { Symbol } from '../../core/symbole';
import { Karte, Knopf, useDaten } from '../../core/ui';
import { ANBIETER_NAME, chatOeffnen } from './api';
import { ChatKnopf } from './Chat';
import { KiSeite } from './Seite';
import { SchluesselSeite } from './Schluessel';
import './stil.css';

function KiKarte({ projekt }: ModulSeiteProps) {
  const status = useDaten(() => api.get<KiStatus>(modulPfad(projekt.id, 'ki', 'status')), [projekt.id]);
  const offen = useDaten(() => api.get<KiVorschlag[]>(modulPfad(projekt.id, 'ki', 'vorschlaege?status=offen')), [projekt.id]);
  const s = status.daten;
  return (
    <Karte titel={<Link to={`/p/${projekt.id}/ki`}>KI-Hilfe</Link>}>
      <div className="stapel">
        <span className="leise">
          {projekt.kiAnbieter === 'aus'
            ? 'In diesem Projekt ausgeschaltet.'
            : !s
              ? 'Prüft …'
              : s.jetzt
                ? `Bereit: ${ANBIETER_NAME[s.jetzt]}${s.jetzt === 'lokal' && !s.lokal.geladen ? ' (startet bei Bedarf)' : ''}`
                : 'Gerade keine KI erreichbar.'}
        </span>
        {!!offen.daten?.length && (
          <Link to={`/p/${projekt.id}/ki`}>
            {offen.daten.length} {offen.daten.length === 1 ? 'Vorschlag wartet' : 'Vorschläge warten'} auf dich
          </Link>
        )}
        {projekt.kiAnbieter !== 'aus' && (
          <div>
            <Knopf klein onClick={() => chatOeffnen(null)}>
              Frage stellen
            </Knopf>
          </div>
        )}
      </div>
    </Karte>
  );
}

const ki: WebModul = {
  id: 'ki',
  name: 'KI-Hilfe',
  reihenfolge: 90,
  symbol: Symbol.ki,
  Seite: KiSeite,
  Karte: KiKarte,
  Ueberall: ChatKnopf,
  // Zugangsdaten der KI – nur der Hauptadmin (der Server prüft das selbst).
  GlobalSeite: SchluesselSeite,
  globalName: 'Schlüssel',
  globalSichtbar: (ich) => ich.istHauptadmin,
};
export default ki;
